import { ref ,shallowRef,watch} from '@vue/composition-api'
import { GardenReportService } from '@/app/reports/garden/services/garden.report.service'

  
import  ReportOptions from  '@/views/reports/components/options.js'

const  {defaultFromdate,defaultTodate} =ReportOptions()


export default function gardenReportLogic() {

  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const request = ref({
    page: 1,
    length: 25,
    type: 'gardenPlan',
    from: defaultFromdate,
    to: defaultTodate,
   
    workDays: ['Saturday','Sunday','Monday','Tuesday','Wednesday','Thursday','Friday'],
    period:'daily',
    plans: [],
  })

  const report_data = shallowRef(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)
  const dataTableloading = ref(false)

  

  watch([sortBy,isSortDirDesc],()=>{
   
    request.value.sortBy=  isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc';
    dataTableloading.value=true
    GardenReportService.getReport(request.value)
    .then(res => {
      report_data.value = res.data.data
      from.value = res.data.from
      to.value = res.data.to
      total.value = res.data.total
       
    })
    .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
    .finally(() =>  dataTableloading.value = false)
  })

  const getReport = (laoding_form=true) => {

    errors.value = {}
    loading.value = true
    
    GardenReportService.getReport(request.value)
      .then(res => {
        report_data.value = res.data.data
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
         
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  loading.value = false)
  }



  const getReportForPdf = () => {
    return new Promise((r, j) => {
      GardenReportService.getReport(Object.assign(request.value, {
        page:1, length: 50000
      })).then(res => r(res.data.data))
    })
  }


  return {
    getReport,getReportForPdf,
    report_data,
    total, from, to,
    request,
    loading,
    dataTableloading,
    errors,
     sortBy,
     isSortDirDesc

  }
}
